import { render, staticRenderFns } from "./ItemDescriptionAutocomplete.vue?vue&type=template&id=48bf1212&scoped=true"
import script from "./ItemDescriptionAutocomplete.vue?vue&type=script&lang=js"
export * from "./ItemDescriptionAutocomplete.vue?vue&type=script&lang=js"
import style0 from "./ItemDescriptionAutocomplete.vue?vue&type=style&index=0&id=48bf1212&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48bf1212",
  null
  
)

export default component.exports